import color from "color-convert";

function fromHex(hex) {
    return color.hex.hsl.raw(hex);
}

export const tones = {
    state: Array.from(Array(9).keys()).map(i => (((i + 1) * 100)) + ''), // initial state
    reducers: {
        updateColorSpace(state, {name, newSpace}) {
            state[name].colorSpace = newSpace;

            return state;
        },
    },
};

export const colors = {
    state: {
        blue: {
            colorSpace: 'hsl',
            colors: {
                100: fromHex('EBF8FF'),
                200: fromHex('BEE3F8'),
                300: fromHex('90CDF4'),
                400: fromHex('63B3ED'),
                500: fromHex('4299E1'),
                600: fromHex('3182CE'),
                700: fromHex('2B6CB0'),
                800: fromHex('2C5282'),
                900: fromHex('FF4365'),
            }
        },
        red: {
            colorSpace: 'hsl',
            colors: {
                100: fromHex('FEE2E2'),
                200: fromHex('FECACA'),
                300: fromHex('FCA5A5'),
                400: fromHex('F87171'),
                500: fromHex('EF4444'),
                600: fromHex('DC2626'),
                700: fromHex('B91C1C'),
                800: fromHex('991B1B'),
                900: fromHex('7F1D1D'),
            }
        },
        green: {
            colorSpace: 'hsl',
            colors: {
                100: fromHex('D1FAE5'),
                200: fromHex('A7F3D0'),
                300: fromHex('6EE7B7'),
                400: fromHex('34D399'),
                500: fromHex('10B981'),
                600: fromHex('059669'),
                700: fromHex('047857'),
                800: fromHex('065F46'),
                900: fromHex('064E3B'),
            }
        },
    }, // initial state
    reducers: {
        updateColorSpace(state, {name, newSpace}) {
            state[name].colorSpace = newSpace;

            return state;
        },
        // handle state changes with pure functions
        updateColor(state, {id, name, color}) {
            state[name].colors = {
                ...state[name].colors,
                [id]: [...color],
            };
            return state;
        },
    },
};
